import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from "vuetify/es5/util/colors";
import { Ripple } from "vuetify/lib/directives"

Vue.use(Vuetify);

const opts =
{
  //   components: {
  //     VApp,
  //     VNavigationDrawer,
  //     VFadeTransition,
  //     VLayout,
  //     VCard,
  //     VCardTitle,
  //     VCardText,
  //     VCardActions,
  //     VSheet
  //   },

  directives: {
    Ripple
  },

  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#6200EE",
        secondary: "#15B9A6",
        accent: "#F34747"
      },
      dark: {
        primary: "#6200EE",
        secondary: "#15B9A6",
        accent: "#F34747"
      }
    }
  },

  icons: {
    iconfont: "mdi", // default
    values: {
      pages_vehicles: "mdi-car",
      pages_home_card: "mdi-chart-donut",
      pages_market_place: "mdi-storefront-outline",
      pages_timeline: "mdi-chart-timeline-variant",
      pages_rewards: "mdi-gift-outline",
      pages_profile: "mdi-face-man-profile",
      pages_policy: "mdi-file-document-outline",
      pages_faq: "mdi-chat-question-outline",
      pages_contact: "mdi-message-text-outline",
      pages_about: "mdi-information-outline",

      actions_download: "mdi-download",
      actions_add: "mdi-plus",
      actions_more: "mdi-chevron-right",
      open_new: "mdi-open-in-new",
      actions_share: "mdi-share-variant-outline",
      actions_share_fill: "mdi-share-variant",
      actions_logout: "mdi-logout-variant",
      actions_take_photo: "mdi-camera-plus-outline",
      actions_retake_photo: "mdi-camera-retake-outline",
      actions_drag: "mdi-drag-variant",
      actions_delete: "mdi-delete-outline",

      camera_take_photo: "mdi-camera-outline",
      camera_retake_photo: "mdi-camera-retake-outline",
      camera_switch: "mdi-camera-flip-outline",
      check_circle: "mdi-check-circle",
      pencil_circle: "mdi-pencil-circle",

      global_alert: "mdi-alert",
      global_info: "mdi-exclamation-thick",
      global_check: "mdi-check",
      global_clock: "mdi-timeline-clock-outline",
      global_clock_time_five: "mdi-clock-time-five-outline",
      global_timer: "mdi-timer-sand",
      global_required: "mdi-asterisk",
      global_back: "mdi-chevron-left",
      global_close: "mdi-close",
      global_camera_location: "mdi-camera-marker-outline",
      global_location: "mdi-map-marker-radius-outline",
      global_offline: "mdi-signal-off",
      global_weak_signal: "mdi-signal-cellular-1",
      global_cellphone: "mdi-cellphone",
      global_email: "mdi-email",
      global_checkin: "mdi-clock-check-outline",
      global_checkAll: "mdi-check-all",
      global_cloud_off: "mdi-cloud-off-outline",
      global_cloud_check: "mdi-cloud-check-variant-outline",

      calendar_google: "mdi-google",
      calendar_microsoft_office: "mdi-microsoft-office",
      calendar_microsoft_outlook: "mdi-microsoft-outlook",
      calendar_ics: "mdi-calendar-clock",

      auth_google: "mdi-google",
      auth_apple: "mdi-apple",
      auth_facebook: "mdi-facebook",
      auth_email: "mdi-email-outline",
      auth_sms: "mdi-cellphone",

      appstore:"mdi-apple",
      playstore:"mdi-google-play",
      web:"mdi-web",
      wallet:"mdi-wallet",
    }
  }
};

export default new Vuetify(opts);
